import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import reducers from './reducers/index';
import api from './middleware/api';

const store = createStore(
  reducers,
  composeWithDevTools(
    applyMiddleware(api)
    // other store enhancers if any
  )
);

export default store;
